import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lottie from "react-lottie";
import animationData from "../../../assets/LottiFiles/CrossAnimation.json";
import { Autoplay } from "swiper/modules";

interface Props {
  onClose: () => void;
  onDelete: () => void;
  heading?: string;
  subHeading?: string;
}

function DeleteAgentList({ onClose, onDelete, subHeading, heading }: Props) {
  const defaultOptions = {
    loop: false,
    Autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    // <AnimatePresence>
    <div className="createbot-modal">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="flex-cnt mx-4 w-[680px] flex-col rounded-[10px] bg-[linear-gradient(180deg,_#FB5F66_-51.8%,_#FFFFFF_70.59%)] p-[40px]">
          <Lottie options={defaultOptions} height={150} width={150} />
          <h2 className="mb-[10px] !text-[18px] font-medium text-text-clr">
            {heading ? heading : "Delete Action"}
          </h2>
          <p className="mb-[30px] max-w-[300px] text-center !text-[14px] text-[#444444CC]">
            {subHeading
              ? subHeading
              : "Are you sure you want to delete this action? This action cannot be undone."}
          </p>

          <div className="flex justify-end gap-4">
            <motion.button
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.5 },
              }}
              whileTap={{ scale: 0.9 }}
              onClick={onClose}
              className="h-[45px] w-[170px] rounded-[6px] border border-primary-clr text-[14px] text-primary-clr"
            >
              Cancel
            </motion.button>
            <motion.button
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.5 },
              }}
              whileTap={{ scale: 0.9 }}
              onClick={onDelete}
              className="w-[170px] rounded-[6px] border border-primary-clr bg-primary-clr text-[14px] text-white"
            >
              Delete
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
    // </AnimatePresence>
  );
}

export default DeleteAgentList;

export const DeleteImg = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="40" cy="40" r="40" fill="white" fill-opacity="0.2" />
    <circle
      cx="40.0003"
      cy="40.0028"
      r="35.0877"
      fill="white"
      fill-opacity="0.36"
    />
    <rect
      x="11.2275"
      y="11.2314"
      width="57.5439"
      height="57.5439"
      rx="28.7719"
      fill="white"
    />
    <rect
      x="25.4565"
      y="25.4512"
      width="29.0909"
      height="29.0909"
      rx="14.5455"
      fill="#FB5F66"
    />
    <mask
      id="mask0_1985_58994"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="34"
      y="34"
      width="12"
      height="12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7671 36.2104L36.2216 34.7559L40.0035 38.5377L43.7853 34.7559L45.2398 36.2104L41.458 39.9922L45.2398 43.774L43.7853 45.2286L40.0035 41.4468L36.2216 45.2286L34.7671 43.774L38.5489 39.9922L34.7671 36.2104Z"
        fill="white"
        stroke="white"
        strokeWidth="1.16364"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </mask>
    <g mask="url(#mask0_1985_58994)">
      <path d="M33.021 33.0156H46.9846V46.9793H33.021V33.0156Z" fill="white" />
    </g>
  </svg>
);
